import "regenerator-runtime";
import { createMetaManager } from "vue-meta";
import { plugin as vueMetaPlugin } from "vue-meta";

import { createApp } from 'vue';
import { createStore } from 'vuex';
import App from './App.vue';
//import './registerServiceWorker'
import router from './router';
//import VueGtag from 'vue-gtag-next';

const store = createStore({
	state() {
		return {
			displayLoginPopup: false,
			displayPasswordPopup: false,
			storeIsAuthenticated: false,
			underConstructionActive: true,
			displayChangeUsernamePopup: false,
			getUserData: null,
			getUserLevel: 'dalton',
			getUserSubscriptions: [],
			getRentedMedia: [],
			getRentedMediaIDs: [],
			getEnumLookup: null,
            getContentTypes: {
                faq: "4a3c4bed-e690-4c4f-80d9-2f2eab976453",
            },
			getVixyParams: {
                partner: 641,
                uiconfid: 23459913,
            },
            getBodyBackgroundUrl: false,
		};
	},
	mutations: {
		toggleLoginPopup(state) {
			state.displayLoginPopup = !state.displayLoginPopup;
		},
		showLoginPopup(state) {
			state.displayLoginPopup = true;
		},
		hideLoginPopup(state) {
			state.displayLoginPopup = false;
		},
		togglePasswordPopup(state) {
			state.displayPasswordPopup = !state.displayPasswordPopup;
		},
		showPasswordPopup(state) {
			state.displayPasswordPopup = true;
		},
		hidePasswordPopup(state) {
			state.displayPasswordPopup = false;
		},
		storeSetAuthenticated(state) {
			state.storeIsAuthenticated = true;
		},
		storeRemoveAuthenticatedStatus(state) {
			state.storeIsAuthenticated = false;
		},
		removeUnderConstruction(state) {
			state.underConstructionActive = false;
		},
		hideChangeUsernamePopup(state) {
			state.displayChangeUsernamePopup = false;
		},
		showChangeUsernamePopup(state) {
			state.displayChangeUsernamePopup = true;
		},
		setUserData(state, data) {
			state.getUserData = data;
		},
		deleteUserData(state) {
			state.getUserData = null;
		},
		//New
		saveUserSubscriptions(state, data) {
			state.getUserSubscriptions = data;
		},
		saveRentedMedia(state, data) {
			state.getRentedMedia = data;
		},
		saveRentedMediaIDs(state, data) {
			state.getRentedMediaIDs = data;
		},
		deleteUserSavedData(state) {
			state.getUserSubscriptions = [];
			state.getRentedMedia = [];
			state.getRentedMediaIDs = [];
		},
		saveEnumLookup(state, data) {
			state.getEnumLookup = data;
		},
        saveBodyBackgroundUrl(state, data) {
			state.getBodyBackgroundUrl = data;
		},
	}
});

const app = createApp(App);
app.config.devtools = true;

//TMP
app.config.unwrapInjectedRef = true;

// app.use(VueGtag, {
// 	property: {
// 		id: 'G-PWH7XRN8SK',
// 		anonymizeIp: true
// 	}
// });

app.use(store);
app.use(router);

app.use(vueMetaPlugin);
app.use(createMetaManager());

app.mount('#app');
